<template>
  <CVButton
    v-if="isVisible"
    type="button"
    variant="ghost"
    :class="props.class"
    :is-loading="isLoading"
    @click="handleCall"
  >
    <PhoneIcon class="h-4 w-4" />
    <slot></slot>
  </CVButton>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { useAbility } from '@casl/vue';
import { useDialCall } from '@/queries/use-phone';
import { Phone as PhoneIcon } from 'lucide-vue-next';
import { useMe } from '@/queries/use-users';
import CVButton from './buttons/CVButton.vue';

const props = withDefaults(
  defineProps<{
    phoneNumber?: string | null;
    class?: HTMLAttributes['class'];
  }>(),
  {
    phoneNumber: null,
    class: '-my-2 ml-2 h-4 w-4',
  },
);

const ability = useAbility();
const { data: user } = useMe();

const canCall = computed(() => ability.can('ros', 'Phone'));
const hasSipId = computed(() => Boolean(user.value?.sipId));
const hasPhone = computed(() => Boolean(props.phoneNumber?.trim()));

const isVisible = computed(() => canCall.value && hasSipId.value && hasPhone.value);

const { mutateAsync: dial, isPending: isLoading } = useDialCall();

async function handleCall() {
  await dial(props.phoneNumber!);
}
</script>
